/**
 * Détecte si l'utilisateur est sur un vrai appareil mobile (téléphone) via User-Agent.
 * Bloque les téléphones mais autorise les tablettes et desktops.
 * Utilisé par le guard de route pour rediriger les mobiles.
 */
export function isTrueMobileDevice(): boolean {
  const ua = navigator.userAgent || '';
  return /Android.*Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
}

/**
 * Détecte si l'écran est trop petit (< 768px).
 * Utilisé pour l'overlay réactif sur desktop (resize de fenêtre).
 */
export function isScreenTooSmall(): boolean {
  return window.innerWidth < 768;
}

/**
 * Détecte si l'utilisateur est sur un appareil mobile (téléphone).
 * Bloque les téléphones mais autorise les tablettes et desktops.
 *
 * Critères :
 * - User-Agent mobile (iPhone, Android phone, etc.)
 * - OU écran < 768px en fallback
 */
export function isMobileDevice(): boolean {
  return isTrueMobileDevice() || isScreenTooSmall();
}
